import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from './core/user.service';
import { Global } from './core/Global';

@Injectable()
export class ContractProcessService {
	private url: string;

	constructor(
		private _http: HttpClient,
		private _userService: UserService,
	) {
		this.url = Global.url_seguros + 'policy-charges-v2/';
	}

	generateInit(coverage: any, month: any, uf: any): Observable<any> {
		return this._http.post(this.url + 'generate/init', { coverage, month, uf })
	}

	processRequests(coverage: any, month: any): Observable<any> {
		return this._http.post(this.url + 'generate/requests', { coverage, month })
	}

	syncDependents(coverage: any, month: any, offset = 0, limit = 0): Observable<any> {
		return this._http.post(this.url + 'calculate/sync-dependents', { coverage, month, offset, limit })
	}

	generateCoveredLives(coverage: any, month: any): Observable<any> {
		return this._http.post(this.url + 'generate/covered-lives', { coverage, month })
	}

	calculateInit(coverage: any, month: any): Observable<any> {
		return this._http.post(this.url + 'calculate/init', { coverage, month })
	}

	calculateIncorporation(coverage: any, month: any): Observable<any> {
		return this._http.post(this.url + 'calculate/incorporation', { coverage, month })
	}

	calculateModify(coverage: any, month: any): Observable<any> {
		return this._http.post(this.url + 'calculate/modify', { coverage, month })
	}

	calculateNormal(coverage: any, month: any, offset = 0, limit = 0): Observable<any> {
		return this._http.post(this.url + 'calculate/normal', { coverage, month, offset, limit })
	}
}
